import {
    Button,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
} from "@material-ui/core";
import {
    Add,
} from "@material-ui/icons";
import { showAddItemsDialog } from "../items-add/items-add-slice";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right"
    },
    buttonText: {
      color: "#111111",
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    },
    typography: {
        color:"#111111",
    }
}));

const ItemsListEmpty = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const handleAddOpen = () => {
        dispatch(showAddItemsDialog());
    };

    return (
        <>
            <Typography className={classes.title} variant="h4">Items</Typography>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<Add/>}
                    onClick={handleAddOpen}
                >
                    Add
                </Button>
            </div>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" className={classes.tableHeader}>Code</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Description</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>OP</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Increase (%)</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>UP</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Type</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Status</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Deposit</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                </Table>
            </TableContainer>
            <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                <Typography className={classes.typography}>
                    No items found.
                </Typography>
            </div>
        </>
        
    );
};

export default ItemsListEmpty;